import { httpCodes } from '@shared/constants/httpCodes'

import BaseHTTPError from './BaseHTTPError'

export default class TooManyRequestsError<Data> extends BaseHTTPError<Data> {
  constructor(info: { message: string; action: string; data?: Data }) {
    super({
      name: TooManyRequestsError.name,
      httpCode: httpCodes.TOO_MANY_REQUESTS,
      message: info.message,
      action: info.action,
      data: info?.data
    })
  }
}
